import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useLocation, Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { Form, Divider as AntdDivider, Button, message, notification, Space } from 'antd';
import { userLogin } from '../../api/User';
import { useDispatch } from 'react-redux';
import { setToken, setUser, setTwoFA } from '../../features/user/userSlice';
import { userVerifyResend } from '../../api/Verfiy';
import { CustomInput, CustomInputPassword } from '../../components/CustomForm';
import ReCAPTCHA from "react-google-recaptcha";
import {WalletLogin} from "./components/WalletLogin";

const LoginContainer = styled.div`
  width: 100%;
  min-height: calc(100vh - 184px);
  /* background-color: rgba(0, 0, 0, 0.1); */
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  & > * {
    margin-right: 15px;
  }
`;

const Title = styled.h2`
  font-size: 32px;
  color: #fff;
`;

const Content = styled.div`
  width: 470px;
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
`;

const LoginContent = styled.div`
  display: flex;
  flex-direction: column;
  //align-items: center;
  gap: 40px;
  align-items: stretch;
  .ant-form-item:last-child {
    margin-bottom: 0;
  }
`

const Divider = styled.div`
  width: 1px;
  background: #181818;
  margin-top: 10px;
  margin-bottom: 20px;
`

const LoginPage = () => {
  // 多语言Hooks
  const { t } = useTranslation();
  // 跳转Hooks
  const navigate = useNavigate();
  // 路由hooks
  const location = useLocation();
  // reduxHooks
  const dispatch = useDispatch();
  // 表单对象
  const [form] = Form.useForm();

  // 定义变量
  const [loading, setloading] = useState(false);

  const [params] = useSearchParams()

  // 初始化数据
  useEffect(() => {

    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      navigate('/');
      // if (moment(user.Expiration).isBefore(moment())) {
      //   form.setFieldsValue({
      //     email: user.email,
      //   });
      // }
    }
    // try {
    //   const { userName } = location.state;
    //   form.setFieldsValue({ email: userName });
    // } catch (error) {}
  }, [location.state]);

  // 发送邮件
  const sendEmail = async (email) => {
    try {
      const { code } = await userVerifyResend({ email });
      if (code === '10000') {
        message.success('Mail sent successfully');
        navigate('/register/verfiytip', {
          state: { from: '/register', userName: email },
          replace: true,
        });
      }
    } catch (error) {}
  };

  const toInfo = () => {
    navigate('/user', { state: { wallet_address: true } });
  };

  const captchaRef = useRef(null);

  // 表单提交
  const onFinish = async (values) => {
    setloading(true);
    try {
      //google recaptcha
      if (captchaRef.current) {
        const token = await captchaRef.current.executeAsync();
        captchaRef.current.reset();
        values.response_token = token;
      }

      const res = await userLogin(values);

      if (res.code === '10000') {
        if (res.data.user.email_verified) {
          //2-FA校验
          if(res.data.user.two_fa){
            navigate(`/login/2fa?id=${res.data.user.id}`);
            return;
          }

          message.success(t('loginPage.message.success'));
          setloading(false);
          if (!res.data.user.wallet_address && res.data.user.type !== 1) {
            notification.warning({
              key:'warning',
              message: '',
              description: (
                <span
                  style={{
                    fontSize: '16px',
                  }}
                >
                  Please set your wallet address before submitting your report.
                </span>
              ),
              duration: 5000,
              btn: (
                <Button
                  size="small"
                  style={{
                    height: '32px',
                    backgroundColor: '#18EAC4',
                    borderColor: '#18EAC4',
                    color: '#000',
                    borderRadius: '6px',
                  }}
                  onClick={() => {
                    notification.close('warning');
                    navigate('/user?page=my_info', { state: { wallet_address: true } });
                  }}
                >
                  Setting
                </Button>
              ),
            });
            setTimeout(() => {
              navigate('/');
            }, 2000);
          }else if(params.get('redirect_url')){
            if(params.get('redirect_url') !== '/login'){
              navigate(params.get('redirect_url'));
            }
            navigate('/');
          }else{
            setTimeout(() => {
              navigate('/');
            }, 2000);
          }

          dispatch(setUser(res.data));
          dispatch(setToken(`${res.data.type} ${res.data.token}`));
          dispatch(setTwoFA(res.data.user.two_fa));
        } else {
          sendEmail(values.email);
        }
      } else {
        setloading(false);
      }
    } catch (error) {
      setloading(false);
    }

    setloading(false);
  };

  // 处理表单错误
  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };

  return (
    <LoginContainer>
      <Content>
        <Title>{t('loginPage.Login')}</Title>
        <LoginContent>
          <Form
              form={form}
              // {...formItemLayout}
              name="basic"
              initialValues={{ remember: true }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
          >
            <Form.Item>
              <div
                  style={{
                    color: '#4B555E',
                  }}
              >
                {t("loginPage.Don't have an account yet?") + ' '}
                <Link to={'/register'} style={{ color: '#fff' }}>
                  {' ' + t('loginPage.Go to create a')}
                </Link>
              </div>
            </Form.Item>
            <Form.Item
                name="email"
                rules={[
                  { required: true, message: 'Please input your email' },
                  { type: 'email', message: 'The input is not valid email' },
                ]}
            >
              <CustomInput
                autoComplete='email'
                placeholder={t('loginPage.email_tip')}
              />
            </Form.Item>

            <Form.Item
                name="password"
                rules={[{ required: true, message: 'Please input your password' }]}
            >
              <CustomInputPassword
                autoComplete='current-password'
                  placeholder={t('loginPage.password_tip')}
              />
            </Form.Item>
            {/* <Form.Item>
            <div
              style={{
                display: 'flex',
              }}
            >
              <Input
                style={{
                  height: '42px',
                  borderRadius: '6px',
                }}
              />
              <div
                style={{
                  width: '120px',
                  height: '42px',
                  marginLeft: '20px',
                  backgroundColor: '#fff',
                  borderRadius: '6px',
                }}
              ></div>
            </div>
          </Form.Item> */}

            {/* <Form.Item name="remember" valuePropName="checked">
            <Checkbox>{t('loginPage.Remember me')}</Checkbox>
          </Form.Item> */}
            <Form.Item>
              {
                process.env.REACT_APP_SITE_KEY && (
                      <ReCAPTCHA
                          sitekey={process.env.REACT_APP_SITE_KEY}
                          ref={captchaRef}
                          size={'invisible'}
                          theme={'dark'}
                      />
                  )
              }
              <ButtonGroup>
                <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    style={{
                      height: '42px',
                      paddingLeft: 30,
                      paddingRight: 30,
                      backgroundColor: '#18EAC4',
                      borderColor: '#18EAC4',
                      color: '#000',
                      borderRadius: '4px',
                    }}
                >
                  {t('login')}
                </Button>
                <Button
                    type="link"
                    style={{
                      color: '#18EAC4',
                      textDecoration: 'underline'
                    }}
                >
                  <Link to="/users/forget_password_send_email">
                    {t('loginPage.Forgotpassword')}
                  </Link>
                </Button>
              </ButtonGroup>
            </Form.Item>
          </Form>
          {/*<Divider />*/}
          <WalletLogin />
        </LoginContent>
      </Content>
    </LoginContainer>
  );
};

export default LoginPage;
